// import React from 'react';
// import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
// import Dashboard from './components/Dashboard';
// import Preferences from './components/Preferences';
// import Sidemenu from './components/side-menu/SideMenu';
// import Form from './Forms/Form';
// import Login from './Auth/Login';  // Import the Login component
// import useToken from './constant/AuthToken';
// import ViewExpression from './components/View';
// import Thankyou from './Forms/components/Thankyou';

// import { FormProvider } from './Forms/components/FormContext'; // Import the FormProvider

// function App() {
//   const { token, setToken } = useToken();  // Using the custom useToken hook

//   return (
//     <div className="wrapper">
//       <div className="logocount">
//         <div>
//           <div>
//           </div>
//           <div>
//             <img className="formlogo" src={'https://www.jaipuriaschools.com/images/logo.png'} alt="logo" />
//           </div>
//         </div>
//         <FormProvider>  {/* Wrap Form with FormProvider */}

//         <Router>
//           <Routes>
//             {/* Login route */}
//             {/* <Route path="/login" element={<Login setToken={setToken} />} /> */}

//             {/* Form always shown at the root */}
//             <Route
//               path="/"
//               element={
//                   <Form />
//               }
//             />
//              <Route path="/thankyou" element={<Thankyou />} /> 

//             {/* Protected routes: only accessible if token exists */}
//             {/* {token ? (
//               <> */}
//                 <Route path="/dashboard" element={<Dashboard />} />
//                 <Route path="/view/:id" element={<ViewExpression />} />
//                 <Route path="/preferences" element={<Preferences />} />
               
//               {/* </>
//             ) : ( */}
//               {/* <Route path="*" element={<Navigate to="/login" />} />  // Redirect to login if no token */}
//             {/* )} */}
//           </Routes>
//         </Router>
//         </FormProvider>

//       </div>
//     </div>
//   );
// }

// export default App;

import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Preferences from './components/Preferences';
import Sidemenu from './components/side-menu/SideMenu';
import Form from './Forms/Form';
import ViewExpression from './components/View';
import Thankyou from './Forms/components/Thankyou';
import { FormProvider } from './Forms/components/FormContext';

function App() {
  return (
    <div className="wrapper">
      <div className="logocount">
        <div>
          <div></div>
          <div>
            <img
              className="formlogo"
              src={'https://www.jaipuriaschools.com/images/logo.png'}
              alt="logo"
            />
          </div>
        </div>

        <FormProvider>
          <Router>
            <Routes>
              <Route path="/" element={<Form />} />
              <Route path="/thankyou" element={<Thankyou />} />
              <Route path="/login" element={<Dashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/view/:id" element={<ViewExpression />} />
              <Route path="/preferences" element={<Preferences />} />
              {/* Optional: Add fallback 404 page */}
              {/* <Route path="*" element={<NotFound />} /> */}
            </Routes>
          </Router>
        </FormProvider>
      </div>
    </div>
  );
}

export default App;

